export let InvoicePaymentMethodStatus;

(function (InvoicePaymentMethodStatus) {
  InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
  InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
})(InvoicePaymentMethodStatus || (InvoicePaymentMethodStatus = {}));

export let InvoiceDisplayStatus;

(function (InvoiceDisplayStatus) {
  InvoiceDisplayStatus["Issued"] = "issued";
  InvoiceDisplayStatus["PaymentInitiated"] = "paymentInitiated";
  InvoiceDisplayStatus["Paid"] = "paid";
  InvoiceDisplayStatus["Overdue"] = "overdue";
  InvoiceDisplayStatus["Voided"] = "voided";
  InvoiceDisplayStatus["Refunded"] = "refunded";
  InvoiceDisplayStatus["RefundFailed"] = "refundFailed";
  InvoiceDisplayStatus["PaymentDisputed"] = "disputed";
})(InvoiceDisplayStatus || (InvoiceDisplayStatus = {}));

export let InvoicePaymentDisplayStatusType;

(function (InvoicePaymentDisplayStatusType) {
  InvoicePaymentDisplayStatusType["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentDisplayStatusType["PaymentMethodUnverified"] = "paymentMethodUnverified";
  InvoicePaymentDisplayStatusType["PaymentFailed"] = "paymentFailed";
  InvoicePaymentDisplayStatusType["Paid"] = "paid";
  InvoicePaymentDisplayStatusType["PaidExternally"] = "paidExternally";
  InvoicePaymentDisplayStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoicePaymentDisplayStatusType["RequiresPaymentValidation"] = "requiresPaymentValidation";
  InvoicePaymentDisplayStatusType["Processing"] = "processing";
  InvoicePaymentDisplayStatusType["Collected"] = "collected";
  InvoicePaymentDisplayStatusType["Refunded"] = "refunded";
  InvoicePaymentDisplayStatusType["RefundFailed"] = "refundFailed";
  InvoicePaymentDisplayStatusType["Pending"] = "pending";
  InvoicePaymentDisplayStatusType["StoppedPayment"] = "stoppedPayment";
  InvoicePaymentDisplayStatusType["Disputed"] = "disputed";
})(InvoicePaymentDisplayStatusType || (InvoicePaymentDisplayStatusType = {}));

export let InvoiceStatusEnum;

(function (InvoiceStatusEnum) {
  InvoiceStatusEnum["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoiceStatusEnum["PaymentActionRequired"] = "paymentActionRequired";
  InvoiceStatusEnum["PaymentFailed"] = "paymentFailed";
  InvoiceStatusEnum["Pending"] = "pending";
  InvoiceStatusEnum["ProcessingCharge"] = "processingCharge";
  InvoiceStatusEnum["PaymentConfirmed"] = "paymentConfirmed";
  InvoiceStatusEnum["Paid"] = "paid";
  InvoiceStatusEnum["PaidExternally"] = "paidExternally";
  InvoiceStatusEnum["Voided"] = "voided";
  InvoiceStatusEnum["Refunded"] = "refunded";
  InvoiceStatusEnum["RefundFailed"] = "refundFailed";
  InvoiceStatusEnum["PaymentStopped"] = "paymentStopped";
  InvoiceStatusEnum["PaymentDisputed"] = "paymentDisputed";
})(InvoiceStatusEnum || (InvoiceStatusEnum = {}));